import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import rehypeStringify from "rehype-stringify";
import remarkGridTables from "remark-grid-tables";
import rehypeReact from "rehype-react";
import React from "react";
import rehypeRaw from "rehype-raw";
import * as prod from 'react/jsx-runtime'
import visit from "unist-util-visit";

import { rehype } from 'rehype';
import MarkdownImage from "./MarkdownImage";
import MarkdownCode from "./MarkdownCode";
import ReactQuote from "components/lexical/plugin/quote/ReactQuote";
import MarkdownBookRecommandation from "./MarkdownBookRecommandation";
import MarkdownDocument from "./MarkdownDocument";

// TODO: handle multiline <p> in table items
function sanitizeGridTables(theString) {
    if (!theString)
        return theString;
    let newString = "";
    let inTable = false;
    let lastHorizontal = false;
    let firstLine = true;
    for (const line of theString.split("\n")) {
        if (firstLine && line.trim().startsWith("[") && line.trim().endsWith("]")) {
            // this is to separate [ DOC TITLE: ... ] from the remainder of the body
            newString += line + "\n\n";
        } else {
            if (!inTable) {
                // if you're not in a table and meet a nice
                // +---------------+ line: whack! That's a table!
                if (line.trim().startsWith("+-") && line.trim().endsWith("-+")) {
                    inTable = true;
                    lastHorizontal = true;
                    // detach, so that it can be parsed properly by remark
                    newString += "\n";
                }
            } else {
                // check if you're still in a table
                const isHorizontal =
                    (line.trim().startsWith("+-") || line.trim().startsWith("+ ")) &&
                    (line.trim().endsWith("-+") || line.trim().endsWith(" +"));
                if (
                    !(
                        (line.trim().startsWith("|") && line.trim().endsWith("|")) ||
                        (line.trim().startsWith("+=") && line.trim().endsWith("=+")) ||
                        (!lastHorizontal && isHorizontal)
                    )
                ) {
                    // previous table is ended, but you could be right into
                    // the next table!
                    inTable = isHorizontal;
                    // detach, so that it can be parsed properly by remark
                    newString += "\n";
                }
                lastHorizontal = isHorizontal;
            }
            newString += line + "\n";
        }
        firstLine = false;
    }
    return newString;
}

function replaceDocumentReferences(md) {
    return md.replace(/@@\[(.*?)\]/g, "[$1](document_reference)");
}

// Funzione per convertire HTML in componenti React
export function convertHtmlToReact(htmlString, isSource, metadata) {
    // Creazione del processore Rehype
    const processor = rehype().use(rehypeReact, {
        createElement: React.createElement,
        Fragment: prod.Fragment,
        jsx: prod.jsx,
        jsxs: prod.jsxs,
        passNode: true,
        components: {
            // Associazione di elementi HTML a componenti React personalizzati
            img: (props) => <MarkdownImage src={props.src} alt={props.src} isSource={isSource} />,
            //p: ({ children }) => <div>{children}</div>,
            prog: () => <></>,
            clear: () => <></>,
            code: (props) => <MarkdownCode {...props} />,
            h1: ({ children }) => <div className="font-semibold text-lg mt-3 first:mt-1">{children}</div>,
            h2: ({ children }) => <div className="font-bold text-xl mt-3 first:mt-1">{children}</div>,
            blockquote: ({ children }) => <ReactQuote content={children} />,
            recom: (props) => <MarkdownBookRecommandation metadata={metadata} {...props} />,
            typo: ({ children }) => <span className="underline decoration-wavy decoration-orange decoration-1">{children}</span>,
            document: (props) => <MarkdownDocument {...props} />,
            comment: <></>
        },
    });

    // Parsing dell'HTML in un AST (Abstract Syntax Tree)
    //console.log("HTML", htmlString);
    const k = processor.parse(htmlString);
    //console.log("parsed", k);
    const tmp = k.children.find((el) => el.tagName === "html").children;
    //console.log("Coglione", tmp);
    //if (tmp === undefined) console.log("CAZZZONw", k);
    const ast = tmp.find((el) => el.tagName === "body");
    ast.tagName = "div";
    // Conversione dell'AST in un componente React
    const react = processor.stringify(ast);
    return react;
}

function documentTag() {
    return (tree) => {
        visit(tree, 'link', (node, index, parent) => {
            if (node.url === "document_reference") {
                const uuid = node.children[0].value
                parent.children.splice(index, 1, {
                    type: 'documentTag',
                    value: uuid,
                });
            }
        });
    };
}

function preProcess(md) {
    const tmp = sanitizeGridTables(md);
    return replaceDocumentReferences(tmp);
}

function log() {
    return (tree) => console.log(tree);
}

export async function processMarkdown(md) {
    try {
        const processed = await unified()
            .use(remarkParse)
            .use(documentTag)
            .use(remarkGridTables)
            .use(remarkRehype, {
                allowDangerousHtml: true, handlers: {
                    documentTag(state, node) {
                        const result = { type: "element", tagName: "document", properties: { uuid: node.value } };
                        return result;
                    }
                }
            })
            //.use(log)
            .use(rehypeRaw)
            .use(rehypeStringify)
            .process(preProcess(md));
        return processed.value;
    } catch (e) {
        return e;
    }

}